export default __webpack_public_path__ + "static/media/checkbox-disabled.986d2f67.svg";